// extracted by mini-css-extract-plugin
export var actionText = "_me-4";
export var container = "_me-0";
export var leftSection = "_me-1";
export var rightSection = "_me-2";
export var settingsButton = "_me-6";
export var settingsIcon = "_me-7";
export var shortcut = "_me-5";
export var shortcutGroup = "_me-3";